

exports.__esModule = true;
exports.module = void 0;
var _angular = _interopRequireDefault(require("angular"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _module = exports.module = _angular["default"].module;


//////////////////
// WEBPACK FOOTER
// ../node_modules/squid/dist/ng/module.js
// module id = ../node_modules/squid/dist/ng/module.js
// module chunks = 0